function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get; } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return _get(target, property, receiver || target); }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import CustomHTMLElement from 'html-element';
import './assets/date.js';
import './assets/number.js';

var FormattedTime = /*#__PURE__*/function (_CustomHTMLElement) {
  _inherits(FormattedTime, _CustomHTMLElement);

  var _super = _createSuper(FormattedTime);

  function FormattedTime() {
    _classCallCheck(this, FormattedTime);

    return _super.apply(this, arguments);
  }

  _createClass(FormattedTime, [{
    key: "_runSetup",
    value: //////////
    function _runSetup() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      _get(_getPrototypeOf(FormattedTime.prototype), "_runSetup", this).call(this);

      if (!this.format) {
        this.format = options.format || this.getAttribute('data-format') || this._defaultFormat;
      }

      if (!this.locale) {
        this.locale = options.locale || this.getAttribute('data-locale') || FormattedTime.defaultLocale;
      }

      if (!this.timezone) {
        this.timezone = options.timezone || this.getAttribute('data-timezone') || FormattedTime.defaultTimezone;
      }

      if (!this.date) {
        if (options.date) {
          this.date = options.date;
        } else {
          this.timestamp = options.timestamp || this.getIntegerAttribute('data-timestamp');
        }
      }
    } ////////// Attributes

  }, {
    key: "timestamp",
    get: function get() {
      return this._timestamp;
    },
    set: function set(newValue) {
      this._timestamp = newValue;

      if (newValue || newValue === 0) {
        var timestamp = parseInt(newValue) * 1000;
        this.date = new Date(timestamp);
      } else {
        this.date = null;
      }
    }
  }, {
    key: "date",
    get: function get() {
      return this._date;
    },
    set: function set(newValue) {
      if (typeof newValue === 'string') {
        this._date = new Date(newValue);
      } else {
        this._date = newValue;
      }

      this.updateDisplay();
    } ////////// Formatting

  }, {
    key: "format",
    get: function get() {
      return this._format;
    },
    set: function set(newValue) {
      try {
        this._format = JSON.parse(newValue);
      } catch (e) {
        if (FormattedTime.formats.hasOwnProperty(newValue)) {
          this._format = FormattedTime.formats[newValue];
        } else {
          this._format = newValue;
        }
      }
    }
  }, {
    key: "updateDisplay",
    value: function updateDisplay() {
      if (!this.date) {
        this.innerText = '';
        this.title = '';
        return;
      }

      switch (_typeof(this.format)) {
        case 'object':
          var options = Object.assign({}, this.format);
          options.timeZone = this.timezone;
          this.innerText = this.date.toLocaleString(this.locale, options);
          this.title = '';
          break;

        case 'string':
          switch (this.format) {
            case 'time':
              this.innerText = this.date.toLocaleTimeString(this.locale, {
                timeZone: this.timezone
              });
              this.title = '';
              break;

            case 'date':
              this.innerText = this.date.toLocaleDateString(this.locale, {
                timeZone: this.timezone
              });
              this.title = '';
              break;

            case 'datetime':
              this.innerText = this.date.toLocaleString(this.locale, {
                timeZone: this.timezone
              });
              this.title = '';
              break;

            case 'relative':
              this.innerText = this.date.toRelativeString();
              this.title = this.date.toLocaleString(this.locale, {
                timeZone: this.timezone
              });
              break;

            case 'relative-short':
            case 'relative_short':
              this.innerText = this.date.toRelativeShortString();
              this.title = this.date.toLocaleString(this.locale, {
                timeZone: this.timezone
              });
              break;

            case 'duration-short':
            case 'duration_short':
              this.innerText = this.timestamp.toShortDurationString();
              this.title = this.innerText;
              break;

            case 'duration':
              this.innerText = this.timestamp.toDurationString();
              this.title = this.innerText;
              break;

            case 'duration-long':
            case 'duration_long':
              this.innerText = this.timestamp.toLongDurationString();
              this.title = this.innerText;
              break;
          }

          break;
      }
    }
  }], [{
    key: "formats",
    get: ////////// Configuration
    // Date Formats
    function get() {
      if (!this._formats) {
        this._formats = {
          time_short: {
            hour: '2-digit',
            minute: '2-digit'
          },
          date_short: {
            month: 'numeric',
            day: 'numeric'
          },
          date_long: {
            year: 'numeric',
            month: 'long',
            weekday: 'short',
            day: 'numeric'
          },
          datetime_short: {
            month: 'numeric',
            day: 'numeric',
            hour: 'numeric',
            minute: '2-digit'
          },
          datetime_long: {
            year: 'numeric',
            month: 'long',
            weekday: 'short',
            day: 'numeric',
            hour: 'numeric',
            minute: '2-digit'
          },
          month_short: {
            year: '2-digit',
            month: 'short'
          },
          month_long: {
            year: 'numeric',
            month: 'long'
          }
        };
      }

      return this._formats;
    },
    set: function set(newValue) {
      this._formats = newValue;
    }
  }, {
    key: "defaultFormat",
    get: function get() {
      return this._defaultFormat;
    },
    set: function set(newValue) {
      this._defaultFormat = newValue;
    } // Locale Override

  }, {
    key: "defaultLocale",
    get: function get() {
      return this._defaultLocale;
    },
    set: function set(newValue) {
      this._defaultLocale = newValue;
    }
  }, {
    key: "defaultTimezone",
    get: function get() {
      return this._defaultTimezone;
    },
    set: function set(newValue) {
      this._defaultTimezone = newValue;
    }
  }]);

  return FormattedTime;
}(CustomHTMLElement);

export { FormattedTime as default };
window.customElements.define('formatted-time', FormattedTime);

Date.prototype.toFormattedString = function (format) {
  var options = FormattedTime.formats[format];
  return this.toLocaleTimeString(undefined, options);
};